import { pageClass, pageHeader, ExcelBtn, pdfBtn, formBtn1, formBtn2, inputClass } from "../../Components/Utils/CustomClasses";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { customStyles, downloadCSV, downloadTablePDF } from "../../Components/Utils/CommonFuntion";
import { useState, useEffect, useRef } from "react";
import { DatePicker, Space } from "antd"; 
import Table from "../../Components/Table/Table";
import { getUserTalkTimeAPI, StaticUserAPI } from "../../API/Api";
import usePaginatedData from "../../Components/Utils/UsePagination";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { useThemeColor } from "../../Components/Sidebar/SideBarApi";
import ButtonLoader from "../../Components/Loader/ButtonLoader";
import { LeadStatusStyles } from "../../Components/Utils/StaticData";

export default function TalkTime() {
    const { control,reset,register,watch,handleSubmit } = useForm();
    const filterTimeout = useRef();
    const isFirstRender = useRef(true);
    const [ariaFocusMessage, setAriaFocusMessage] = useState("");
    const [isApplyDisabled, setIsApplyDisabled] = useState(true); 
    const [showTalkTime, setShowTalkTime] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false); 
    const [AssignUsers, setAssignUsers] = useState([]);
    const [totalTalkTime, setTotalTalkTime] = useState("");
    const [loading, setLoading] = useState(false); 
    const [userTalkTime, setUserTalkTime] = useState([]);
    const onMenuOpen = () => setIsMenuOpen(true);
    const onMenuClose = () => setIsMenuOpen(false);
    const { RangePicker } = DatePicker; 
    const themeColor = useThemeColor();
    const user = watch("user"); 
    const rangeDate = watch("rangeDate");
    const UserDetails = useSelector((state) => state?.login?.userDetails);

    const initialFilterState = {
        p:1,
        startDate: "",
        endDate: "",
        userId: UserDetails?._id || "", 
      };
    
      const [filterObject, setFilterObject] = useState({ ...initialFilterState });
    
      const {
        filterData: tableData,
        pageNo,
        records,
        pageChangeHandler,
        fetchData,
        recordChangeHandler,
        nextIsValid,
        prevIsValid,
        loader,
      } = usePaginatedData(1, 50, getUserTalkTimeAPI, filterObject);

    const filterRecords = () => {
        if (filterTimeout.current) {
          clearTimeout(filterTimeout.current);
        }
        filterTimeout.current = setTimeout(async () => {
          try {
                await fetchData({ ...filterObject });
              } finally {
                setLoading(false);
                filterTimeout.current = null;
              }
        }, 1500);
        return () => {
          if (filterTimeout.current) {
            clearTimeout(filterTimeout.current);
          }
        };
      };
    
      useEffect(() => {
        if (isFirstRender.current) {
          isFirstRender.current = false; // Prevent first API call from `useEffect`
          return;
        }
        filterRecords();
      }, [filterObject]); 
    
      useEffect(() => {
        setIsApplyDisabled(!(user || rangeDate));
      }, [user, rangeDate]);

        const filterSubmit = async (data) => {
        setLoading(true);
        setShowTalkTime(true);

        let startDateFormatted = "";
        let endDateFormatted = "";

        if (data?.rangeDate && data.rangeDate.length === 2) {
            const startDate = `${data.rangeDate[0].$D}-${data.rangeDate[0].$M + 1}-${data.rangeDate[0].$y}`;
            const endDate = `${data.rangeDate[1].$D}-${data.rangeDate[1].$M + 1}-${data.rangeDate[1].$y}`;

            startDateFormatted = moment(startDate, "DD-MM-YYYY").format("DD-MM-YYYY");
            endDateFormatted = moment(endDate, "DD-MM-YYYY").format("DD-MM-YYYY");
        }

        const payload = {
            userId: data?.user?.value || UserDetails?._id,
            startDate: startDateFormatted,
            endDate: endDateFormatted     
        };

        try {
            const res = await getUserTalkTimeAPI(payload);

            const time = res?.data?.formattedTalkTime || "00:00:00";
            setTotalTalkTime(time);

            setFilterObject(prev => ({
                ...prev,
                ...payload
            }));
            } finally {
                setLoading(false);
            }
        };

    const assignToOptions =
    AssignUsers != undefined
      ? AssignUsers.map((user) => ({
          value: user?._id,
          label: `${user?.first_name} ${user?.last_name} - ${user?.role?.roleName}`,
        }))
      : [{ value: "", label: "No data found" }];

    const fetchUsers = async () => {
        try {
          let response = await StaticUserAPI({
            id: UserDetails?._id,
            role: UserDetails?.role?.roleName,
            company:
              UserDetails?.role?.roleName === "SuperAdmin"
                ? ""
                : UserDetails?.company?._id,
          });
          setAssignUsers(response?.data?.filteredData);
        } catch (err) {
          console.log("Error fetching users:", err);
        }
    };
    useEffect(() => {
        fetchUsers();
    }, []);
      
    const safeFormatTime = (value) => {
        if (!value || value === "---") return "---";

        const m = moment(value, [
            "hh:mm:ss A",
            "hh:mm A",
            "HH:mm:ss",
            "HH:mm",
            moment.ISO_8601
        ], true);

        return m.isValid() ? m.format("hh:mm A") : "---";
    };

      const submitPdfExcel =  (download) => {

            const Header = [
                "employeeName",
                "createdAt",
                "leadName",
                "callStart",
                "callEnd",
                "talkTime",
                "followDate",
                "followTime",
                "leadStatus",
                "subLeadStatus",
                "remark",
            ];
        
        const formattedData = tableData?.map((data) => ({
          ...data,
          employeeName: data?.user?.first_name && data?.user?.last_name ? `${data?.user?.first_name} ${data?.user?.last_name}` : "---",
          createdAt: data?.createdAt ? moment(data?.createdAt).format("YYYY-MM-DD") : "---",  
          leadName: data?.lead?.firstName && data?.lead?.lastName ? `${data?.lead?.firstName} ${data?.lead?.lastName}` : "---", 
          callStart: data?.callStart ? moment(data?.callStart).format("YYYY-MM-DD hh:mm:ss A") : "---",       
          callEnd: data?.callEnd ? moment(data?.callEnd).format("YYYY-MM-DD hh:mm:ss A") : "---", 
          talkTime: formatDurationReal(data?.callDurationMinutes),      
          followDate: data?.followDate ? moment(data?.followDate).format("YYYY-MM-DD") : "",       
          followTime: `'${safeFormatTime(data?.followTime)}`,
            
        }));
        download === "Csv"
          ? downloadCSV(Header, formattedData, "TalkTime")
          : downloadTablePDF(Header, formattedData, "TalkTime");
      };

    const formatDurationReal = (minutes) => {
        if (!minutes || isNaN(minutes)) return "0 sec";

        const duration = moment.duration(minutes, "minutes");

        const mins = Math.floor(duration.asMinutes());
        const secs = duration.seconds();

        if (mins === 0) return `${secs} sec`;
        return `${mins} min ${secs} sec`;
    };


    const tableColumns = [
        {
            field: "employeeName",
            header: "Employee Name",
            style: true,
            body: (row) => (
                <h6>
                   { row?.user?.first_name && row?.user?.last_name ? `${row?.user?.first_name} ${row?.user?.last_name}` : "---" }
                </h6>
            ),
        },
        {
            field: "createdAt",
            header: "Created At",
            style: true,
            body: (row) => (
                <h6>
                { row?.createdAt ? moment(row?.createdAt).format("DD-MM-YYYY") : "---"}
                </h6>
            ),
        },
        {
            field: "leadName",
            header: "Lead Name",
            style: true,
            body: (row) => (
                <h6>
                  { row?.lead?.firstName || row?.lead?.lastName ? `${row?.lead?.firstName} ${row?.lead?.lastName}` : "---" }
                </h6>
            ),
        },
        {
            field: "callStart",
            header: "Call Start",
            style: true,
            body: (row) => (
                <h6>
                {row?.callStart ? moment(row?.callStart).format("DD-MM-YYYY hh:mm:ss A") : "---"}
                </h6>
            ),
        },
        {
            field: "callEnd",
            header: "Call End",
            style: true,
            body: (row) => (
                <h6>
                {row?.callEnd ? moment(row?.callEnd).format("DD-MM-YYYY  hh:mm:ss A") : "---"}
                </h6>
            ),
        },
        {
            field: "formattedTalkTime",
            header: "Talk Time",
            style: true,
            body: (row) => (
                <h6>
                {formatDurationReal(row.callDurationMinutes)}
                </h6>
            ),
        },
        {
          field: "followUpDetails",
          header: "FDetails",
          style: true,
          body: (row) => {
            const followDate = row?.followDate || "";
            const followTime = row?.followTime || "";
            const followDateDetails = (followDate) ? moment(followDate).format("DD-MM-YYYY") : "-----";
            const followTimeDetails = (followTime) ? `${followTime}` : "-----";
            return(
              <>
                <h6>{followDateDetails}</h6>
                <h6>{followTimeDetails}</h6>
              </>
            );
          },
        },
        {
            field: "leadStatus",
            header: "Lead Status",
            style: true,
            body: (row) => <LeadStatusStyles leadStatus={row?.leadStatus} />
        },
        {
            field: "subLeadStatus",
            header: "Sub Lead Status",
            style: true,
            body: (row) => (
                <h6>
                { row?.subLeadStatus || "---"}
                </h6>
            ),
        },
        {
            field: "remark",
            header: "Remark",
            style: true,
            body: (row) => (
                <h6>
                { row?.remark || "---"}
                </h6>
            ),
        }
    ];
    return (
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader} text-xl md:text-2xl lg:text-3xl`}>
              Talk Time
            </h1>
            <div className="flex sm:mb-0 sm:mr-2 mt-2 justify-end">
              <button
                className={ExcelBtn}
                onClick={() => submitPdfExcel("Csv")}
              >
                Excel
              </button>
              <button className={pdfBtn} onClick={() => submitPdfExcel("Pdf")}>
                PDF
              </button>
            </div>
          </div>
          <form onSubmit={handleSubmit(filterSubmit)} className="mt-4">
            <div className="flex flex-col lg:flex-row gap-3">
              {/* FILTERS DIV */}
              <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                {/* USER SELECT */}
                <div>
                  <Controller
                    name="user"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        styles={customStyles}
                        aria-labelledby="aria-label"
                        inputId="aria-example-input"
                        onMenuOpen={onMenuOpen}
                        onMenuClose={onMenuClose}
                        options={assignToOptions}
                        placeholder="Select User"
                        maxMenuHeight={220}
                        isClearable={true}
                      />
                    )}
                  />
                </div>
                {/* DATE RANGE */}
                <div className="w-full">
                  <Space direction="vertical" size={12} className="w-full">
                    <Controller
                      name="rangeDate"
                      control={control}
                      render={({ field }) => (
                        <RangePicker
                          {...field}
                          className="w-full h-[48px] rounded-lg border border-[#DFDFDF] bg-[#F9FAFB] px-3 shadow-none hover:shadow-none focus:shadow-none"
                        />
                      )}
                    />
                  </Space>
                </div>
                {/* TALK TIME */}
                <div className={`${showTalkTime ? "block" : "hidden"}`}>
                  <label className="block text-sm font-semibold text-black mb-1">
                    Total Talk Time
                  </label>
                  <p className="text-base font-semibold text-center text-black p-2 rounded-lg bg-gray-100">
                    {totalTalkTime || "0hr 0min 0sec"}
                  </p>
                </div>
              </div>

              {/* BUTTON DIV */}
              <div className="flex gap-2 justify-end flex-shrink-0 items-center">
                {loading ? (
                  <ButtonLoader />
                ) : (
                  <button
                    type="submit"
                    className={`${formBtn1} ${
                      isApplyDisabled
                        ? "opacity-50 cursor-not-allowed"
                        : "bg-base-color"
                    }`}
                    disabled={isApplyDisabled}
                  >
                    Apply
                  </button>
                )}
                <button
                  type="button"
                  className={`${formBtn2} ${
                    isApplyDisabled ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  onClick={() => {
                    reset({ user: null, rangeDate: null });
                    setFilterObject(initialFilterState);
                    setShowTalkTime(false);
                  }}
                  disabled={isApplyDisabled}
                >
                  Clear
                </button>
              </div>
            </div>
          </form>
          <div className="min-w-[361px] sm:min-w-[400px] p-0 sm:p-[3.5rem] rounded-lg">
            <div className="flex flex-col sm:flex-row">
              <div className="w-full">
                <div className="mt-4">
                  <Table
                    columns={tableColumns}
                    data={tableData}
                    paginatorCheck={true}
                    prevIsValid={prevIsValid}
                    nextIsValid={nextIsValid}
                    pageNo={pageNo}
                    records={records}
                    pageChangeHandler={pageChangeHandler}
                    recordChangeHandler={recordChangeHandler}
                    register={register}
                    loading={loader}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}   